module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-6-f5fd89704455c1138942d15e52df2c14.webp";